import React from "react";

import { useErrorNotification } from "@common/components/Notification";
import { resetLogo } from "@services/logo";
import ConfirmDialog from "@common/components/Button/DeleteButton/dialog";

interface DeleteAttachmentDialogProps {
  open?: boolean;
  onClose?: (b: boolean) => void;
  objectId?: string;
  logoClass: string;
  deleteAddingUserLogo?: () => void;
  isEdit?: boolean;
}

const DeleteDialog = (
  props: React.PropsWithChildren<DeleteAttachmentDialogProps>
) => {
  const {
    open = false,
    onClose = () => {},
    objectId = "",
    logoClass,
    deleteAddingUserLogo,
    isEdit,
  } = props;
  const dispatchError = useErrorNotification();
  const onConfirm = async () => {
    try {
      if (deleteAddingUserLogo) {
        deleteAddingUserLogo();
      }
      if (isEdit) {
        await resetLogo(objectId, logoClass);
      }
      onClose(true);
    } catch (e) {
      dispatchError(e);
    }
  };
  return (
    <ConfirmDialog
      open={open}
      onClose={() => {
        onClose(false);
      }}
      onConfirm={onConfirm}
      actionLabel={"Remove"}
      confirmPrompt={"This will remove the logo. Do you want to proceed?"}
    />
  );
};

export default DeleteDialog;
